<template>
    <div class="famous-comment-bottom-bar-box">
        <!-- <div v-show="focused" class="famous-comment-bottom-bar-bg" @click.stop="clickBottomBg"></div> -->
        <div class="famous-comment-bottom-bar">
            <!-- 0. 正在回复 -->
            <!-- <div v-if="commentTextAreaToName != ''" class="famous-comment-input-title"><span class="famous-comment-input-title-span">{{commentFormData.parentsid != 0 ? '正在回复' : '正在评论'}}</span><span>{{commentTextAreaToName}}</span></div> -->
            <!-- 1. 聊天输入框 -->
            <div class="famous-comment-input-bar dsp-flex" v-bind:class="{'famous-comment-input-bar-focus': focused}">
                <!-- 暂时不要emoji表情输入 -->
                <!-- <div class="famous-comment-bottom-item" @click="clickExpButton">
                    <span class="famous-cbi-expression">
                        <i class="iconfont icon-expression"></i>
                    </span>
                </div> -->
                <div class="famous-comment-bottom-input-item" v-bind:class="{'focused': focused}">
                    <!-- <input ref="famousinput" type="text" hidden > -->
                    <textarea ref="famoustext" id="commentText" v-bind:placeholder="commentTextAreaToName != '' ? (commentFormData.parentsid != 0 ? '正在回复'+commentTextAreaToName : '正在评论'+commentTextAreaToName) : (showPediaCommentAllList ? '添加评论...' : '正在评论命盘整体分析')" class="famous-comment-bottom-textarea" name="" cols="30" rows="1" maxlength="150" v-model="textValue" @focus="focusTextArea" @blur="blurTextArea" @input="inputTextArea" v-to-famous-textarea="textareaFocus"></textarea>
                    <div id="commentFakeText" class="famous-comment-bottom-fake-textarea" @click="clickFakeTextarea"></div>
                </div>
                <div class="famous-comment-bottom-item" @click="clickSend">
                    <span class="famous-cbi-send">发布</span>
                </div>
            </div>
            <!-- 2. 表情列表框 -->
            <div v-if="showExpressions" class="discuss-bottom-expression-list famous-comment-expression-list">
                <van-swipe indicator-color="white" :loop="false" :stop-propagation="false" :initial-swipe='curIndex' @change="onChange">
                    <van-swipe-item v-for="expList of expressionList" v-bind:key="'expression-' + expList.length + Math.random(0, 10)">
                        <span v-for="expression of expList" v-bind:key="'expression-' + expression + Math.random(0, 10)" @click.stop="clickExpression(expression)">{{expression.content}}</span>
                    </van-swipe-item>
                </van-swipe>
                <div class="discuss-bottom-expression-bar dsp-flex">
                    <div class="discuss-beb-item" @click="clickDelete"><span><i class="iconfont icon-jianpanguanbi"></i></span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import he from 'he'
import { UA } from '../../modules/utils'
import { FAMOUS_DOM, DOM } from '../../modules/dom'
import edit from '../../modules/store/modules/edit'
import { CONFIG } from '../../modules/config'
export default {
    name: 'FamousCommentBottomBar',
    directives : {
        "to-famous-textarea" : function (el, binding) {
            if(binding.value){
                setTimeout(() => { el.focus() }, 300);
            }
        }
    },
    computed: {
        showPediaCommentAllList() {
            return this.$store.state.famouspediacomment.showPediaCommentAllList
        },
        commentFormData() {
            return this.$store.state.famouspediacomment.commentFormData
        },
        commentTextAreaToName() {
            return this.$store.state.famouspediacomment.commentTextAreaToName
        },
        expressionList() {
            return this.$store.state.famouspediacomment.expressionList
        }
    },
    data() {
        return {
            focused: false,
            textValue: '',
            canSend: false,
            showExpressions: false,
            curIndex: 0,
            textareaFocus: false
        }
    },
    mounted() {
        this.$bus.on('focusFamousBottomBar', this.focusBottomInput);
    },
    destroyed() {
        this.$bus.off('focusFamousBottomBar', this.focusBottomInput);
    },
    methods: {
        focusBottomInput() {
            // this.textareaFocus = true;
        },
        initDom() {
            var me = this,
                topDom = document.getElementsByClassName('famous-pedia-fate-topbar')[0],
                bgDom = document.getElementsByClassName('famous-comment-bottom-bar-bg')[0],
                height = topDom ? innerHeight - topDom.clientHeight : innerHeight;
            this.$el.style.height = height + 'px';
            if(bgDom) {
                bgDom.style.height = height + 'px';
            }
            // 添加屏幕大小变化之后对遮罩层的绘制
            window.onresize = function() {
                setTimeout(() => {
                    me.initDom();
                }, 20);
            }
            window.onorientationchange = function() {
                setTimeout(() => {
                    me.initDom();
                }, 20);
            }
            window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function(){
                setTimeout(() => {
                    me.initDom();
                }, 20);
            }, false);
        },
        resetDom() {
            var me = this,
                topDom = document.getElementsByClassName('famous-pedia-fate-topbar')[0],
                bgDom = document.getElementsByClassName('famous-comment-bottom-bar-bg')[0],
                height = topDom ? innerHeight - topDom.clientHeight : innerHeight;
            this.$el.style.height = '';
            if(bgDom) {
                bgDom.style.height = '';
            }
            var fakeNode = document.getElementById('commentFakeText');
            if(fakeNode) {
                fakeNode.style.display = 'block';
            }
            // 添加屏幕大小变化之后对遮罩层的绘制
            window.onresize = function() {
                setTimeout(() => {
                    me.resetDom();
                }, 20);
            }
            window.onorientationchange = function() {
                setTimeout(() => {
                    me.resetDom();
                }, 20);
            }
            window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function(){
                setTimeout(() => {
                    me.resetDom();
                }, 20);
            }, false);
        },
        clickExpButton() {
            this.showExpressions = !this.showExpressions;
            var fakeNode = document.getElementById('commentFakeText');
            if(fakeNode) {
                fakeNode.style.display = 'block';
            }
            if(this.showExpressions) {
                this.blurTextArea();
            }else {
                this.clickFakeTextarea();
            }
        },
        clickSend() {
            var me = this;
            if(CONFIG.platform == 'web') {
                this.$store.dispatch('weblogin/checkWebLogin');
            }
            // 空的字符串or全是换行符 不发送
            if(this.textValue.match(/^\s+$/) ||
                this.textValue.match(/^[ ]+$/) ||
                this.textValue.match(/^[ ]*$/) ||
                this.textValue.match(/^\s*$/)){
                this.textValue = '';
                this.$toast("您尚未填写内容哟~");
                setTimeout(() => {
                    me.updateTextAreaHeight();
                }, 100);
                return;
            }
            // var commentFormData = this.$store.state.famouspediacomment.commentFormData;
            // if(!commentFormData.bid) {
            //     this.textValue = '';
            //     this.$toast("请先点选要评论的内容哟~");
            //     return;
            // }
            console.error('clickSend')
            this.$store.dispatch('famouspediacomment/addComment', {
                msg: this.textValue,
                sucCb: function() {
                    me.textValue = '';
                    me.$toast('发送评论成功');
                    // 手动更新列表
                    setTimeout(() => {
                        me.$bus.emit('updateCommentListForm');
                    }, 20);
                    setTimeout(() => {
                        me.updateTextAreaHeight();
                    }, 100);
                },
                failCb: function() {
                    me.textValue = '';
                    me.$toast('发送评论失败,请稍后再试');
                    setTimeout(() => {
                        me.updateTextAreaHeight();
                    }, 100);
                }
            })
        },
        focusTextArea() {
            this.focused = true;
            // DOM.setStopTouch();
            var me = this;
            setTimeout(() => {
                me.initDom();
            }, 20);

            if(CONFIG.platform == 'web') {
                this.$store.dispatch('weblogin/checkWebLogin');
            }
        },
        blurTextArea() {
            this.focused = false;
            this.textareaFocus = false;
            var me = this;
            this.resetDom();
            if(CONFIG.platform != 'web') {
                this.$store.state.minifatefortune.showLines = 1;
            }
            FAMOUS_DOM.updateFamousFormStyle();
            setTimeout(() => {
                FAMOUS_DOM.bindFamousFormScrollEvent(true);
            }, 20);

            if(UA.isPcWeChat()) {
                this.unBindKeyDownEvent();
            }else if(UA.isIphone()) {
                setTimeout(() => {
                    FAMOUS_DOM.updateFamousFormStyle();
                }, 20);
            }
            var curId = this.$store.state.famouspedia.curPediaBaziId,
                showPediaCommentAllList = this.$store.state.famouspediacomment.showPediaCommentAllList;
            setTimeout(() => {
                if(showPediaCommentAllList && me.textValue == '' && !me.focused) {
                    this.$store.dispatch('famouspediacomment/resetCommentAllFormData', {
                        bid: curId
                    })
                }
                // DOM.resetStopTouch();
            }, 1000);
        },
        inputTextArea() {
            this.canSend = this.textValue.length > 0 ? true : false;
            this.updateTextAreaHeight();
        },
        clickFakeTextarea() {
            var me = this,
                fakeNode = document.getElementById('commentFakeText'),
                textNode = document.getElementById('commentText'),
                leng = this.textValue.length;
            fakeNode.style.display = 'none';
            textNode.setSelectionRange(leng, leng);
            textNode.focus();

            if(CONFIG.platform != 'web') {
                this.$store.state.minifatefortune.showLines = 0;
            }
            FAMOUS_DOM.updateFamousFormStyle();
            setTimeout(() => {
                FAMOUS_DOM.bindFamousFormScrollEvent(false);
            }, 20);

            if(UA.isPcWeChat()) {
                this.bindKeyDownEvent();
            }else if(UA.isIphone()) {
                // setTimeout(() => {
                //     me.initDom();
                // }, 20);
                setTimeout(() => {
                    FAMOUS_DOM.updateFamousFormBottomBarScrollTop();
                }, 20);
            }
        },
        updateTextAreaHeight() {
            var fakeNode = document.getElementById('commentFakeText'),
                textNode = document.getElementById('commentText');
            if(this.textValue.length == 0) {
                fakeNode.style.height = '';
                textNode.style.height = '';
            }else {
                fakeNode.style.height = textNode.scrollHeight + 'px';
                textNode.style.height = textNode.scrollHeight + 'px';
            }
            // 更新外层的样式和位置
        },
        // 绑定回车按钮事件
        bindKeyDownEvent() {
            var me = this;
            document.onkeydown = function(e) {
                // 兼容FF和IE和Opera
                var event = e || window.event;
                var key = event.which || event.keyCode || event.charCode;
                var bCtrlKeyCode = event.ctrlKey || event.metaKey;
                // ctrl + enter 换行
                if (key == 13 && bCtrlKeyCode) {
                    return;
                }

                if (key == 13) {
                    event.preventDefault();
                    me.clickSend();
                }
            };
        },
        // 撤销绑定回车按钮事件
        unBindKeyDownEvent() {
            document.onkeydown = null;
        },
        clickExpression(expressionData) {
            this.textValue = this.textValue + expressionData.code;
            this.canSend = this.textValue.length > 0 ? true : false;
            this.updateTextAreaHeight();
            return false;
        },
        clickDelete() {
            if(this.textValue == '') {
                return;
            }
            var me = this, curText = he.encode(this.textValue), newText = '',
                lastChar = curText.charAt(curText.length - 1),
                exppChar = curText.charAt(curText.length - 1 - 7),
                expppChar = curText.charAt(curText.length - 1 - 8),
                wordpChar = curText.charAt(curText.length - 1 - 6),
                wordppChar = curText.charAt(curText.length - 1 - 7);
            if(lastChar == ';') {
                if(exppChar == '#' && expppChar == '&') {
                    newText = curText.slice(0, curText.length - 9);
                }else if(wordpChar == '#' && wordppChar == '&'){
                    newText = curText.slice(0, curText.length - 8);
                }else{
                    newText = curText.slice(0, curText.length - 1);
                }
            }else {
                newText = curText.slice(0, curText.length - 1);
            }
            this.textValue = he.decode(newText);
            this.canSend = this.textValue.length > 0 ? true : false;

            setTimeout(() => {
                me.updateTextAreaHeight();
            }, 0);
        },
        onChange(index) {
            this.curIndex = index;
        },
        clickBottomBg() {
            // this.$store.dispatch('famouspediacomment/resetCommentFormData');
            this.resetDom();
        }
    }
}
</script>